<template>
  <div class="uniltwebgl">
    <iframe class="unilt"
            ref="iframe"
            :src=url
            scrolling="no"
            frameborder="0">
    </iframe>
  </div>
</template>

<script>
import { queryShart } from '@/api/user'
import { getUrlParams, wexinShare } from '@/utils/utils'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'gallery',
  data () {
    return {
      url: '',
      id: 3
    }
  },
  computed: {
    title () {
      if (this.id === 5 || this.id === '5') {
        return '林家卫元宇宙美术馆'
      }
      return '徐里元宇宙美术馆'
    },
    desc () {
      if (this.id === 5 || this.id === '5') {
        return '1974年生，福建南平人。艺术家、慈善家、企业家、中国公益事业形象大使。出版有作品集《家卫心语》、《每日一示》、《家卫新永百猴书画集》、《名家百猴展》、《百吉图》、《慢笔》等著作。自2000年以来，先后在国内外举办过三十三次“林家卫雕塑绘画艺术展”。'
      }
      return '当代著名画家，1961年生于福建。作品收藏并陈列于意大利达·芬奇理想博物馆，获得俄罗斯、比利时、吉尔吉斯斯坦、美国等多国颁发的艺术成就奖章；作品连续入选5届全国美展及《20世纪中国油画展》等国家级重大展览，被中国美术馆、中国国家博物馆等重要场馆收藏陈列，是中国当代意象油画的代表画家之一。'
    },
    imgUrl () {
      if (this.id === 5 || this.id === '5') {
        return 'https://artsss.oss-cn-hangzhou.aliyuncs.com/upload/林家卫_1677235362353.jpg'
      }
      return 'https://artsss.oss-cn-hangzhou.aliyuncs.com/upload/徐里_1677235397258.jpg'
    }
  },
  async created () {
    const url = await getUrlParams()
    console.log(url)
    this.id = url.id
    this.url = `http://room.yslt.art/?onSharePage=1&galleryId=${url.id}`
    console.log(location.href)
    this.weixin()
    this.$nextTick(() => {
      this.weixin()
    })
  },
  mounted () {
    this.$refs.iframe.contentWindow.location.href = `http://room.yslt.art/?onSharePage=1&galleryId=${this.id}`
  },
  methods: {
    // 微信二次分享
    async weixin () {
      const res = await queryShart({ url: `${location.href.split('#')[0].toString()}` })
      console.log('分享参数', res)
      wexinShare(res.result, {
        title: this.title,
        desc: this.desc,
        link: `http://room.yslt.art/SharePageTest/?id=${this.id}#/gallery`,
        imgUrl: this.imgUrl
      })
    }
  }
}
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}
//横屏
@media only screen and (orientation: landscape) {

  .uniltwebgl {
    position: relative;
    margin: 0;
    padding: 0;
    // transform: rotate(0deg);
    .unilt {
      // position: absolute;
      width: 100vw;
      height: 100vh;
      display:block !important;
    }
  }
}
//竖屏
@media only screen and (orientation: portrait) {
  .uniltwebgl {
    position: relative;
    transform: rotate(90deg);
    margin: 0;
    padding: 0;
    .unilt {
      width: 100vh;
      height: 100vw;
      display:block !important;
    }
  }
}
</style>
